import type { RuleEdgeProps } from "../types/edges";
import { EDGE_STROKE } from "./BaseEdge";

/**
 * Diameter ST, radius |ST|/2, one 180° arc (bulge picks side via sweep).
 */
function getContinueToStartSemicircleD(
	sx: number,
	sy: number,
	tx: number,
	ty: number,
): string {
	const dx = tx - sx;
	const dy = ty - sy;
	const len = Math.hypot(dx, dy);
	if (len < 2) {
		return `M ${sx} ${sy} L ${tx} ${ty}`;
	}
	const r = len / 2;
	const mx = (sx + tx) / 2;
	// Unit normal to chord S→T (90° CCW from S→T). One semicircle bulges toward M+n*r, the other toward M−n*r.
	const nx = -dy / len;
	const ny = dx / len;
	const bulgeWestX = mx - nx * r;
	const bulgeEastX = mx + nx * r;
	// Bow **west** (smaller flow X): pick the semicircle whose outer apex lies further left.
	const sweep: 0 | 1 = bulgeWestX < bulgeEastX ? 1 : 0;
	return `M ${sx} ${sy} A ${r} ${r} 0 1 ${sweep} ${tx} ${ty}`;
}

/**
 * Continue sentinel `out` (left) → Loop Start `in` (left): geometric semicircle.
 */
const LoopContinueToStartEdge = ({
	id,
	sourceX,
	sourceY,
	targetX,
	targetY,
	markerEnd,
	style = {},
}: RuleEdgeProps) => {
	const d = getContinueToStartSemicircleD(sourceX, sourceY, targetX, targetY);

	return (
		<path
			id={id}
			d={d}
			style={{
				stroke: EDGE_STROKE,
				strokeWidth: 2.5,
				fill: "none",
				...style,
			}}
			markerEnd={markerEnd}
		/>
	);
};

export default LoopContinueToStartEdge;
